/* Tusq · PDP bundle ladder
 *
 * - Clicking a tier sets the qty picker to that tier and highlights it.
 * - Watches the qty input for external changes and updates active state.
 */
(function () {
  'use strict';

  function findQtyInput(scope) {
    // PDP qty picker uses quantity-input web component → fall back to first qty input
    var explicit = scope.querySelector('product-form quantity-input input[type="number"], product-info quantity-input input[type="number"]');
    if (explicit) return explicit;
    return document.querySelector('quantity-input input[type="number"], input[name="quantity"]');
  }

  function applyActive(ladder, qty) {
    var tiers = ladder.querySelectorAll('[data-tier]');
    var bestIdx = -1;
    tiers.forEach(function (t, i) {
      var v = parseInt(t.getAttribute('data-tier'), 10);
      if (qty >= v) bestIdx = i;
    });
    tiers.forEach(function (t, i) {
      if (i === bestIdx) t.setAttribute('data-active', '1');
      else t.removeAttribute('data-active');
    });
  }

  function init() {
    var ladders = document.querySelectorAll('[data-tusq-bundle-ladder]');
    if (!ladders.length) return;

    ladders.forEach(function (ladder) {
      var qtyInput = findQtyInput(ladder.closest('.product, .tusq-product-v2, body') || document);
      if (!qtyInput) return;

      // Click a tier → set qty
      ladder.querySelectorAll('[data-tier]').forEach(function (tier) {
        tier.addEventListener('click', function () {
          var tgt = parseInt(tier.getAttribute('data-tier'), 10);
          if (!tgt) return;
          qtyInput.value = tgt;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          applyActive(ladder, tgt);
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'tusq_bundle_ladder_click',
              tier: tgt
            });
          } catch (e) {}
        });
      });

      // Watch external changes (Shopify's +/- buttons)
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        applyActive(ladder, v);
      });

      // Initial state
      var initial = parseInt(qtyInput.value, 10) || 1;
      applyActive(ladder, initial);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
